module.exports = __webpack_public_path__ + "img/t-shirt--black.d871192.png";